class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.swiper1 = null;
      this.swiper2 = null;
      this.initSwiper();
    }
  }

  // 画像の読み込み完了を待つ
  waitForImages(selector, callback) {
    const images = document.querySelectorAll(`${selector} img`);
    if (images.length === 0) {
      callback();
      return;
    }

    let loadedCount = 0;
    const totalImages = images.length;

    const checkComplete = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        // 画像読み込み完了後、少し待ってから初期化（レンダリング完了を待つ）
        setTimeout(callback, 100);
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        checkComplete();
      } else {
        img.addEventListener("load", checkComplete, { once: true });
        img.addEventListener("error", checkComplete, { once: true });
      }
    });
  }

  initSwiper() {
    // MVスライダーは即座に初期化
    const mvSwiper = new Swiper(".js-mv-slider", {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 2000,
    });

    // 無限スクロールスライダーはPC版のみ（画像読み込み完了を待つ）
    const infiniteSwipers = document.querySelectorAll(
      ".infinite-swiper-1, .infinite-swiper-2",
    );
    if (infiniteSwipers.length > 0) {
      this.syncRecruitSlides();
      this.initInfiniteSwipersIfPc();
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.syncRecruitSlides();
          this.initInfiniteSwipersIfPc();
        }, 250);
      });
    }
  }

  // PC: 10枚 / SP: 20枚（JSで複製）に揃え、PCに影響が出ないようにする
  syncRecruitSlides() {
    const wrappers = document.querySelectorAll(
      ".infinite-swiper-1 .swiper-wrapper, .infinite-swiper-2 .swiper-wrapper",
    );
    wrappers.forEach((wrapper) => {
      const slides = wrapper.querySelectorAll(".swiper-slide:not(.js-sp-only)");
      const duplicates = wrapper.querySelectorAll(".swiper-slide.js-sp-only");

      if (this.isPc()) {
        duplicates.forEach((el) => el.remove());
      } else {
        if (slides.length === 10 && duplicates.length === 0) {
          slides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.classList.add("js-sp-only");
            wrapper.appendChild(clone);
          });
        }
      }
    });
  }

  isPc() {
    return typeof window !== "undefined" && window.innerWidth >= 768;
  }

  initInfiniteSwipersIfPc() {
    if (this.isPc()) {
      if (!this.swiper1 && !this.swiper2) {
        this.waitForImages(".s-recruit__content-swiper-container", () => {
          this.initInfiniteSwipers();
        });
      } else if (this.swiper1 || this.swiper2) {
        this.swiper1?.update();
        this.swiper2?.update();
      }
    } else {
      if (this.swiper1) {
        this.swiper1.destroy(true, true);
        this.swiper1 = null;
      }
      if (this.swiper2) {
        this.swiper2.destroy(true, true);
        this.swiper2 = null;
      }
      // SPでは syncRecruitSlides で20枚になっている
    }
  }

  initInfiniteSwipers() {
    // 既に初期化済みの場合は破棄
    if (this.swiper1) {
      this.swiper1.destroy(true, true);
    }
    if (this.swiper2) {
      this.swiper2.destroy(true, true);
    }

    // 両方のスライダーの初期化完了を追跡
    let swiper1Ready = false;
    let swiper2Ready = false;
    const startAutoplay = () => {
      if (!swiper1Ready || !swiper2Ready) return;
      if (this.swiper1) {
        this.swiper1.update();
        this.swiper1.loopCreate();
        if (this.swiper1.autoplay) this.swiper1.autoplay.start();
      }
      if (this.swiper2) {
        this.swiper2.update();
        this.swiper2.loopCreate();
        if (this.swiper2.slides?.length) {
          this.swiper2.slideTo(this.swiper2.slides.length - 1, 0, false);
        }
        if (this.swiper2.autoplay) this.swiper2.autoplay.start();
      }
    };

    // スライダー1（左→右）
    this.swiper1 = new Swiper(".infinite-swiper-1", {
      loop: true,
      loopAdditionalSlides: 2,
      loopedSlides: 5,
      direction: "horizontal",
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 7500,
      allowTouchMove: false,
      watchOverflow: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        768: {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 50,
          speed: 3500,
          loopedSlides: 5,
        },
      },
      on: {
        init: () => {
          if (this.swiper1) {
            // autoplayを停止（初期化時に自動開始されないように）
            if (this.swiper1.autoplay) {
              this.swiper1.autoplay.stop();
            }

            // ループの設定を確実に完了させる（複数回update）
            this.swiper1.loopCreate();
            this.swiper1.update();

            // すぐに再度update（事前読み込みのため即座に実行）
            setTimeout(() => {
              if (this.swiper1) {
                this.swiper1.update();
                this.swiper1.loopCreate();
              }

              // 初期化完了フラグを立てる
              swiper1Ready = true;
              startAutoplay();
            }, 0); // 0msで即座に実行（事前読み込み）
          }
        },
        resize: () => {
          if (this.swiper1) {
            this.swiper1.update();
          }
        },
      },
    });

    // スライダー2（右→左、逆方向）
    this.swiper2 = new Swiper(".infinite-swiper-2", {
      loop: true,
      loopAdditionalSlides: 2,
      loopedSlides: 5,
      direction: "horizontal",
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 7500,
      allowTouchMove: false,
      watchOverflow: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: true,
      },
      breakpoints: {
        768: {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 50,
          speed: 3500,
          loopedSlides: 5,
        },
      },
      on: {
        init: () => {
          if (!this.swiper2) return;
          if (this.swiper2.autoplay) this.swiper2.autoplay.stop();
          this.swiper2.loopCreate();
          this.swiper2.update();
          setTimeout(() => {
            if (this.swiper2?.slides?.length) {
              this.swiper2.slideTo(this.swiper2.slides.length - 1, 0, false);
            }
            swiper2Ready = true;
            startAutoplay();
          }, 100);
        },
        resize: () => this.swiper2?.update(),
      },
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) return;
      setTimeout(() => {
        this.swiper1?.autoplay?.stop();
        this.swiper1?.autoplay?.start();
        this.swiper2?.autoplay?.stop();
        this.swiper2?.autoplay?.start();
      }, 100);
    });
  }
}
